import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../mobile.setup';
import { MobileEndUsersOverviewTab, MobileEndUsersMetricsTab } from './tabs';

const parent = Mobile.pages.endUsers;
const title = 'PAGE.MOBILE.END_USERS.TITLE';
const tabs: TabPermission[] = [
  MobileEndUsersOverviewTab,
  MobileEndUsersMetricsTab,
];

export const MobileEndUsersPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
